const SettingLayout = () => import(/* webpackChunkName: "setting" */'@/components/setting/SettingLayout')
const AuthorizationList = () => import(/* webpackChunkName: "setting" */'@/components/setting/AuthorizationList')
const AuthorizationMp = () => import(/* webpackChunkName: "setting" */'@/components/setting/AuthorizationMp')
const AuthorizationEnterprice = () => import(/* webpackChunkName: "setting" */'@/components/setting/AuthorizationEnterprice')
const AuthorizationEnterpriceForm = () => import(/* webpackChunkName: "setting" */'@/components/setting/AuthorizationEnterpriceForm')
const AuthorizationMechanic = () => import(/* webpackChunkName: "setting" */'@/components/setting/AuthorizationMechanic')
const AuthorizationShop = () => import(/* webpackChunkName: "setting" */'@/components/setting/AuthorizationShop')
const AuthorizationSecret = () => import(/* webpackChunkName: "setting" */'@/components/setting/AuthorizationSecret')
const TransferPage = () => import(/* webpackChunkName: "setting" */'@/components/setting/TransferPage')
const DataOpenSetting = () => import(/* webpackChunkName: "setting" */'@/components/setting/DataOpenSetting')
const PassWordSetting = () => import(/* webpackChunkName: "setting" */'@/components/setting/PassWordSetting')
const AuthCustomer = () => import(/* webpackChunkName: "setting" */'@/components/setting/AuthCustomer')

export default {
  // name: 'setting',
  path: 'setting',
  component: SettingLayout,
  children: [{
    name: 'authorizations',
    path: 'authorizations',
    component: AuthorizationList,
    meta: {
      module: 'setting',
    },
  }, {
    name: 'authorizationService',
    path: 'authorizations/service',
    component: AuthorizationMp,
    meta: {
      module: 'setting',
    },
  }, {
    name: 'authorizationEnterprice',
    path: 'authorizations/enterprice',
    component: AuthorizationEnterprice,
    meta: {
      module: 'setting',
    },
  }, {
    name: 'authorizationEnterpriceForm',
    path: 'authorizations/enterprice-form',
    component: AuthorizationEnterpriceForm,
    meta: {
      module: 'setting',
    },
  }, {
    name: 'authorizationMechanic',
    path: 'authorizations/mechanic',
    component: AuthorizationMechanic,
    meta: {
      module: 'setting',
    },
  }, {
    name: 'authorizationShop',
    path: 'authorizations/shop',
    component: AuthorizationShop,
    meta: {
      module: 'setting',
    },
  }, {
    name: 'authorizationSecret',
    path: 'authorizations/secret',
    component: AuthorizationSecret,
    meta: {
      module: 'setting',
    },
  }, {
    name: 'transferPage',
    path: 'transferPage',
    component: TransferPage,
    meta: {
      module: 'setting',
    },
  }, {
    name: 'dataOpenSetting',
    path: 'dataOpenSetting',
    component: DataOpenSetting,
    meta: {
      module: 'setting',
    },
  }, {
    name: 'passWordSetting',
    path: 'passWordSetting',
    component: PassWordSetting,
    meta: {
      module: 'setting',
    },
  }, {
    name: 'authCustomer',
    path: 'authCustomer',
    component: AuthCustomer,
    meta: {
      module: 'setting',
    },
  }, {
    path: '/',
    redirect: {name: 'authorizations'},
  }],
}



// WEBPACK FOOTER //
// ./src/router/setting.js